import React, { useState, useRef, useEffect } from "react";
import { useFormik, FormikProps } from "formik";
import * as Yup from "yup";
import { showSuccess, showError } from "toast/toast";
import { useNavigate, useParams } from "react-router-dom";
import { DynamicCost, Warehouse } from "types";
import Select from "react-select";
import { nameValidation, statusValidation } from "validationSchemas/common";
import { getAuthCookie } from "../../utils/authCookies";

const SignageEditDynamicCost = () => {
  const { costId } = useParams<{ costId: string }>();
  const [dynamicCost, setDynamicCost] = useState<any>(null);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState<string | null>(null);
  const [formSubmitting, setFormSubmitting] = useState(false);
  const navigate = useNavigate();
  const token = getAuthCookie("sessionToken");
  const [warehouses, setWarehouses] = useState<any[]>([]);

  console.log(dynamicCost, "edit dynamic")
  useEffect(() => {
    const fetchDynamicCost = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/dynamic-costs/${costId}`,
          // `${process.env.REACT_APP_API_URL}/dynamic-costs`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setDynamicCost(data);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchDynamicCost();
  }, [token]);

  useEffect(() => {
    const fetchWarehouses = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/warehouses`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        setWarehouses(data);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchWarehouses();
  }, [token]);

  const warehousesOptions =
    warehouses?.map((warehouse) => ({
      value: warehouse._id, // Assuming 'id' is a unique string property of Warehouse
      label: warehouse.label,
    })) || [];

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: dynamicCost?.name || "",
      warehouse_id: dynamicCost?.warehouse?._id || "",
      base_cost: dynamicCost?.base_cost || 0,
      distance_covered: dynamicCost?.distance_covered || 0,
      additional_cost_per_mile: dynamicCost?.additional_cost_per_mile || 0,
      statuss: dynamicCost?.status || "Active",
      installation: dynamicCost?.for_installation || false,
      removal: dynamicCost?.for_removal || false,
      checkboxGroup: "",
    },
    validationSchema: Yup.object({
      name: nameValidation,
      statuss: statusValidation,
      installation: Yup.boolean(),
      removal: Yup.boolean(),
      warehouse_id: Yup.string().required("Warehouse is required"),
      checkboxGroup: Yup.string().test(
        "checkbox-required",
        "At least one of Installation or Removal must be selected",
        function (_, context) {
          const { installation, removal } = context.parent;
          return installation || removal;
        }
      ),
      base_cost: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value
        )
        .typeError("Base cost must be a number")
        .required("Base cost is required")
        .min(0),
      distance_covered: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value
        )
        .typeError("Distance covered must be a number")
        .required("Distance covered is required")
        .min(0),
      additional_cost_per_mile: Yup.number()
        .transform((value, originalValue) =>
          originalValue === "" ? undefined : value
        )
        .typeError("Additional cost per mile must be a number")
        .required("Additional cost per mile is required")
        .min(0),
    }),
    onSubmit: async (values) => {
      try {
        const selectedWarehouse = warehouses?.find(
          (warehouse) => warehouse._id === values.warehouse_id
        );

        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/dynamic-costs/${costId}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              name: values.name,
              warehouse: selectedWarehouse,
              base_cost: Number(values.base_cost),
              distance_covered: Number(values.distance_covered),
              additional_cost_per_mile: Number(values.additional_cost_per_mile),
              status: values.statuss,
              for_installation: values.installation === true, // ✅ explicitly true/false
              for_removal: values.removal === true,           // ✅ explicitly true/false
            }),
          });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message || "Failed to create dynamic cost");
        }

        navigate("/signage/dynamic-costs");
        showSuccess("Dynamic cost updated successfully!");
        // toast.success("Dynamic cost added successfully!");
      } catch (error: any) {
        console.error(error);
        showError(`Error: ${error.message}`);
      } finally {
        setFormSubmitting(false);
      }
    }
  });

  return (
    <div className="content">
      <div className="mt-2">
        <h3 className="m-0 text-center fw-bold addheaders">Edit Dynamic Cost</h3>
      </div>
      {/* <h2 className="d-flex justify-content-center">Add Dynamic Cost</h2> */}
      <div className="row ">
        <div className="col-md-12 d-flex justify-content-center">
          <div className="col-md-9">
            <div className="addheaders-content mt-1 card-bg-fill">
              <div className="p-2 px-4 mt-1">
                <form onSubmit={formik.handleSubmit}>
                  <div className=" row cust-margin-4">
                    <div>
                      <h5>Dynamic Details</h5>
                      <hr className="lines" style={{ width: "110px" }} />
                    </div>
                    <div className="col-md-4 " >
                      <label className="form-label">
                        Name of the cost <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.name}
                      />
                      {formik.touched.name && formik.errors.name && (
                        <div className="text-danger mt-1">
                          {formik.errors.name as any}
                        </div>
                      )}
                    </div>
                    <div className="col-md-4 ">
                      <label className="form-label">
                        Base cost <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="base_cost"
                        name="base_cost"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.base_cost}
                      />
                      {formik.touched.base_cost && formik.errors.base_cost && (
                        <div className="text-danger mt-1">{formik.errors.base_cost as any}</div>
                      )}
                    </div>
                    <div className="col-md-4 ">
                      <label className="form-label">
                        Distance covered <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="distance_covered"
                        name="distance_covered"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.distance_covered}
                      />
                      {formik.touched.distance_covered && formik.errors.distance_covered && (
                        <div className="text-danger mt-1">{formik.errors.distance_covered as any}</div>
                      )}
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">
                        Additional cost per mile<span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="additional_cost_per_mile"
                        name="additional_cost_per_mile"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.additional_cost_per_mile}
                      />
                      {formik.touched.additional_cost_per_mile && formik.errors.additional_cost_per_mile ? (
                        <div className="text-danger mt-1">
                          {formik.errors.additional_cost_per_mile as any}
                        </div>
                      ) : null}
                    </div>
                    <div className="col-md-4 br-8 ">
                      <label className="form-label">
                        Warehouse{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Select
                        id="warehouse_id"
                        name="warehouse_id"
                        options={warehousesOptions}
                        closeMenuOnSelect={true}
                        value={warehousesOptions?.find((option) =>
                          formik.values.warehouse_id === option.value
                        )}
                        onChange={(selectedOption) => {
                          console.log("Selected Warehouse:", selectedOption?.value);
                          formik.setFieldValue("warehouse_id", selectedOption ? selectedOption.value : "doute")
                        }
                        }
                        onBlur={formik.handleBlur}
                      />

                      {formik.touched.warehouse_id && formik.errors.warehouse_id && (
                        <div className="text-danger mt-1">{formik.errors.warehouse_id as any}</div>
                      )}
                    </div>
                    <div className="col-md-4 ">
                      <label className="form-label">
                        Status <span className="text-danger">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="statuss"
                        name="statuss"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.statuss}
                      >
                        <option value="">- Select -</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </select>
                      {formik.touched.statuss && formik.errors.statuss && (
                        <div className="text-danger mt-1">{formik.errors.statuss as any}</div>
                      )}
                    </div>
                    <div className="col-md-2 mt-4 ">
                      <div className="d-flex form-check gap-2">
                        <input
                          type="checkbox"
                          name="installation"
                          id="installation"
                          className="form-check-input"
                          onChange={formik.handleChange}
                          checked={formik.values.installation}
                        />
                        <label className="form-check-label mt-1" htmlFor="installation">
                          Installation
                        </label>
                      </div>
                    </div>

                    <div className="col-md-3 mt-4">
                      <div className="d-flex form-check gap-2">
                        <input
                          type="checkbox"
                          name="removal"
                          id="removal"
                          className="form-check-input"
                          onChange={formik.handleChange}
                          checked={formik.values.removal}
                        />
                        <label className="form-check-label mt-1" htmlFor="removal">
                          Removal
                        </label>
                      </div>
                    </div>

                    {/* ✅ Manual render of test() error */}
                    {formik.errors.checkboxGroup && (
                      <div className="text-danger mt-1">{formik.errors.checkboxGroup}</div>
                    )}
                  </div>
                  <div className="row mb-3 rcust-margin-4">
                    <div className="col-md-12 d-flex justify-content-between">
                      <button
                        className="btn btn-outline-secondary br-8 backbutton"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        Back
                      </button>

                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={formSubmitting}
                      >
                        {formSubmitting ? "Submitting..." : "Save"}
                      </button>
                    </div>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignageEditDynamicCost;


